/**
 *
 * @param modulesArray
 * @returns {Array}
 */
export default function (modulesArray) {
	let modules = [];
	modulesArray.filter(module => modules.push(module.name));
	return modules;
}


// WEBPACK FOOTER //
// ./rapid/getModulesNames.helper.js